// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__LS3EU","header":"ClearentDisclaimer_header__1Dr-x","inner":"ClearentDisclaimer_inner__2CErZ"};